var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('el-radio-group', { attrs: { "size": "small" }, model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, _vm._l(_vm.config.params.options, function (item) {
    return _c('el-radio-button', { key: item.value, attrs: { "label": item.value } }, [_vm._v(_vm._s(item.label))]);
  }), 1), _vm._v(" "), _vm.config.params.tip && _vm.config.params.channelId === 21 ? _c('span', { attrs: { "slot": "tip" }, slot: "tip" }, [_vm._v(_vm._s(_vm.config.params.tip))]) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };